// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAITfk_94_apeRipL--T7p7VdaAzFYWyr4",
    authDomain: "swarup-hospital.firebaseapp.com",
    projectId: "swarup-hospital",
    storageBucket: "swarup-hospital.firebasestorage.app",
    messagingSenderId: "889268091603",
    appId: "1:889268091603:web:420039bc604e8569133226",
    measurementId: "G-G2NTSMJPBC"
};

const app = initializeApp(firebaseConfig);

let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.warn('Firebase analytics could not be initialized:', error);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export { analytics };